// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

.ol-control.ol-bar .ol-toggle.ol-active > button, .ol-control.ol-bar .ol-toggle.ol-active button:hover {
  background-color: #008854 !important;
}

body,
html {
  height: 100% !important;
  margin: 0;
  display: flex;
  flex-direction: column;
  background-color: #d9e6de;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

#map {  
  width: 100%;
  height: 100vh;
  flex: 1 1;
  z-index: 0;
  position: absolute;
}

#user-marker {
  width: 16px;
  height: 16px;
  background-color: transparent;
  border: none;
  display: block;
  position: relative;
}

input[type=text],
select,
textarea {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
}

label {
  padding: 6px 6px 6px 0;
  display: inline-block;
}

.ol-ext-dialog {  
  border-radius: 5px;
  padding: 20px;
  color: white; 
  position: fixed;
}

.ol-closebox {
  width: -moz-fit-content !important;
  width: fit-content !important;
  padding: 15px;  
}

.ol-content {
  padding: 10px;
}

.ol-ext-dialog.ol-visible {
  background-color: transparent;
}

.ol-ext-dialog form {
  border-radius: 5px;
  background-color: rgba(28, 62, 29, 0.9) !important;
  /* width: 30% !important; */
  height: auto;
  color: white;
  font-family: Arial, sans-serif;   
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  font-size: 14px;  
}

/* Close Button  */
.ol-ext-dialog form .ol-closebox {
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
  color: white;
  font-size: 15px;
}

/* Form Buttons */
.ol-ext-dialog form .dialog-buttons {
  display: flex;
  justify-content: flex-end;
}

.ol-ext-dialog form .dialog-buttons button {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
  background-color: #374151;
  color: white;
}

.ol-ext-dialog form .dialog-buttons button:hover {
  background-color: #4b5563;
}

.date-dialog {
  width: 35%;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.col-25 {
  flex: 0 0 25%;
  max-width: 25%;
  padding-right: 15px;
  text-align: left;
  float: left;
  width: 25%;
  font-size: 14px;
  font-weight: 600;
  /* margin-top: 6px; */

}

.col-75 {
  flex: 1 1 75% ;
  max-width: 75%;
}

.col-75 input,
.col-75 textarea,
.col-75 select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.error-message {
  color: red;
  font-size: 0.8em;
  margin-top: 5px;
}

.div.ol-ext-dialog.ol-visible > .form > .div.ol-content > .div:nth-child(4) > .div.col-75.dual-listbox > .div:nth-child(3) > .h4 {
  margin: 0%;
}

/* Style for the color, background, and opacity input containers */
input[type="color"],
input[name="background"],
input[name="opacity"] {
  width: 50px !important;
  height: 30px !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 4px !important;
  cursor: pointer;
  display: inline-block;
  margin: 5px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
}


input[name="opacity"] {
  appearance: none;
  background-color: #f0f0f0;
  text-align: center;
}

.col-75.iconpicker-container {
  display: flex;
  align-items: center;
}

.col-75.iconpicker-container i {
  margin-right: 10px;
  font-size: 1em;
  text-align: left;
  flex-shrink: 0;
}

.iconpicker .iconpicker-item {
  float: left;
  width: 20px;
  padding: 6px;
  margin: 0 6px 6px 0;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  font-size: 14px;
  box-shadow: 0 0 0 1px #ddd;
  color: inherit;
}

.row::after {
  content: "";
  display: table;
  clear: both;
}

.dual-listbox {
  display: flex;
  justify-content: space-around;
}

.listbox {
  white-space: nowrap;  
}

.listbox ul {
  list-style-type: none;
  padding: 0;
  border: 1px solid #ccc;
  height: 100px;
  overflow-y: auto;
  border-radius: 4px;
  background-color: #eae4e3;
  color: #1c3e1d;
}

.listbox ul li {
  padding: 5px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.listbox ul li:hover,
.listbox ul li:active,
.listbox ul li:focus {
  background-color: #4b5563;
  border-color: #4b5563;
}

.listbox ul li.selected {
  background-color: #4b5563;
  border-color: #4b5563;
}

.listbox-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.listbox-buttons button {
  margin: 5px 0;
  padding: 8px;  
  background-color: #aecdb1;
  color: #1c3e1d;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn {
  color: white;
  font-size: 20px;
  margin: 26px 24px 0 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  float: right;
  background-color: #374151;
  padding: 10px 15px;
}

@media screen and (max-width: 600px) {

  .col-25,
  .col-75,
  input[type=submit] {
    width: 100%;
    margin-top: 0;
    font-size: 12px;
  }

  .ol-ext-dialog form {    
    top: 15% !important;
    left: 40% !important;
  }

}

.control-bar {
  border-radius: 0px !important;  
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 64px;
  height: 100vh;
  background-color: #1f2937 !important;
  padding: 2px;
  position: relative !important;
  top: 0 !important;
  left: 0 !important;
  overflow: hidden;
}

.control-bar .ol-button button {
  background-color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin-top: 6px;
  border-radius: 8px;
  color: #fff !important;
  text-decoration: none;
  border: none;  
}

.control-bar .ol-button button:hover {
  background-color: #374151;
  color: #fff;
}

/* .dialog-mobile {
  position: absolute;
  top: -35% !important;
  left: 50% !important;
}  */

.dialog-desktop {
  position: absolute;
  top: 50px;
  left: 50px;
}

/* Horizontal top-centered control bar */
.ol-button .ol-unselectable .ol-control,
.base-control-bar {
  border-radius: 0px;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  height: 64px;
  padding: 2px;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
}

.base-control-bar {
  background: transparent !important;
  padding: 0px !important;
}

/* Button styling for the horizontal control bar */
.base-control-bar .ol-button button {
  background-color: #1f2937;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin: 0 8px;
  border-radius: 4px;
  color: #fff;
  text-decoration: none;
  border: none;
}

/* Hover, focus, and active states (but exclude active buttons) */
.base-control-bar .ol-button button:hover {
  background-color: #374151;
  color: #fff;
}

.base-control-bar .ol-button button:active,
.base-control-bar .ol-button button:focus {
  color: #fff !important;
}

.non-fuel {
  margin-top: auto !important;
  margin-bottom: 16px !important;
}

.section {
  padding-right: 6px !important;
  margin-right: 6px !important;
}

.draw-polygon {
  padding-right: 6px !important;
  margin-right: 6px !important;
}

.sidebar-section {
  border-bottom: 1px solid #4b5563;
  padding-bottom: 6px !important;
  margin-bottom: 3px !important;
}

.account {
  margin-top: auto !important;
  margin-bottom: 16px !important;
  background-color: #374151 !important;
}

.account button {
  background-color: transparent !important;
  margin: 0 0 6px 0 !important;
  padding: 0px !important;
}

.account:hover,
.account button:hover {
  background-color: #4b5563 !important;
  color: #d1d5db !important;
}

.ol-notification .ol-close {
  background-color: rgba(63, 99, 71, 0.95);
  color: #ffffff;
  padding: 10px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
}

.ol-notification .ol-close:hover {
  background-color: rgba(63, 99, 71, 0.95);
  color: #ffffff;
  padding: 10px;
  border: 1px solid #ffffff;
  border-radius: 4px;
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}

.uploader {
  width: 24px;
  height: 6px;
  margin-top: 10px;
  background: #FFF;
  display: inline-block;
  position: relative;
}

.uploader::after {
  content: '';  
  left: 50%;
  top: -24px;
  transform: translate(-50%, 0);
  position: absolute;
  border: 8px solid transparent;
  border-bottom-color: #FFF;
  box-sizing: border-box;
  animation: bump 0.4s ease-in-out infinite alternate;
}

.uploader::before {
  content: '';  
  left: 50%;
  bottom: 7px;
  transform: translate(-50%, 0);
  position: absolute;
  width: 8px;
  height: 10px;
  background: #FFF;
  box-sizing: border-box;
  animation: bump 0.4s ease-in-out infinite alternate;
}

@keyframes bump {
  0% {
    transform: translate(-50%, 5px);
  }
  100% {
    transform: translate(-50%, -5px);
  }
}

.loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
}

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #1c3e1d;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: auto;
  display: block;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.sec-loading {
  height: 80px;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.sec-loading .one {
  height: 80px;
  width: 80px;
  border: 4px solid rgb(104, 133, 146);
  transform: rotate(45deg);
  border-radius: 0 50% 50% 50%;
  position: relative;
  animation: move 0.5s linear infinite alternate-reverse;
}

.sec-loading .one::before {
  content: "";
  position: absolute;
  height: 55%;
  width: 55%;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top-color: rgb(104, 133, 146);
  border-bottom-color: rgb(104, 133, 146);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: rotate 1s linear infinite;
}

@keyframes rotate {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes move {
  to {
    transform: translateY(15px) rotate(45deg);
  }
}

.loading h2 {
  color: #33406F;
  font-size: 1.5em;
}

.iconpicker-popover .popover-content .iconpicker {
  height: 150px !important;
}

.iconpicker .iconpicker-item {
  background-color: #374151 !important;
  color: #e6e6e6 !important;
}

.iconpicker .iconpicker-item:hover {
  background-color: #4b5361 !important;
}

#pselect {
  padding: 6px;  
  align-content: center;  
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-label {
  background-color: #f1f1f1;
  padding: 10px;
  cursor: pointer;
  border: 1px solid #ccc;
}

.dropdown-list {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 200px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 10px;
}

.dropdown.on .dropdown-list {
  display: block;
}

.feature-popup {
  background-color: rgba(28, 62, 29, 0.9);
  color: white;
  padding: 10px;
  width: 250px;
  border-radius: 8px;
  z-index: 1000;
  font-size: 14px;
  cursor: default;
}

.feature-popup h2 {
  font-size: 16px;
  margin-bottom: 5px;
}

.non-fuel-dialog {
  position: absolute;
  top: 60%;
  right: 10%;
  transform: translate(-50%, -50%);
  background-color: rgba(28, 62, 29, 0.9);
  color: white;
  padding: 10px;
  width: 250px;
  border-radius: 8px;
  z-index: 1000;
  font-size: 14px;
  cursor: move;
  overflow: auto;
}

.non-fuel-dialog h2 {
  font-size: 16px;
  margin-bottom: 5px;
}

.non-fuel-dialog input {
  width: 100%;
  padding: 6px;
  margin-bottom: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 12px;
}

.non-fuel-dialog p {
  margin-bottom: 5px;
  font-size: 12px;
}

.non-fuel-dialog .dialog-buttons {
  display: flex;
  justify-content: flex-end;
}

.non-fuel-dialog .dialog-buttons button {
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}

.non-fuel-dialog #cancel-btn {
  background-color: #bbb;
  color: #333;
}

.non-fuel-dialog #confirm-btn {
  background-color: #008854;
  color: #fff;
}

.non-fuel-dialog #cancel-btn:hover {
  background-color: #ddd;
}

.non-fuel-dialog #confirm-btn:hover {
  background-color: #4b5563;
}

.non-fuel-dialog .fa-spinner {
  margin-right: 5px;
}

.error {
  color: red !important;
  font-size: 12px !important;
  margin-top: 5px !important;
}

.login-error {
  color: red !important;
  font-size: 16px !important;
}



.coordinates-container {
  margin: 10px 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  position: absolute;
  top: 60px;
  right: 20px;
  font-size: 14px;
  z-index: 1000;
  display: block;
}

.title {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
}

.coordinates h3 {
  margin: 5px 0;
  font-size: 14px;
}

.coordinates p {
  margin: 0;
  padding: 2px 0;
}

.coordinates p:last-child {
  margin-bottom: 0;
}

.information-container {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 10px;
  border-radius: 5px 5px 5px 5px;
  top: 60px;
  left: -300px;
  width: 250px;
  font-size: 14px;
  z-index: 2;
  transition: left 0.3s ease-in-out;
  display: block;
}

.information-container.open {
  left: 100px;
}

@media only screen and (max-width: 767px) {

  /* Hide the information container on mobile devices */
  .information-container {
    display: none;
  }
  
}

.drawer-toggle-button {
  position: relative;
  top: 20px;
  right: 20px;
  background-color: #333;
  color: #fff;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  z-index: 1001;
  border-radius: 5px;
}

.login-form {
  display: block;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 400px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: rgba(56, 65, 81, 0.9);
  color: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  cursor: default;
  z-index: 1000;
}

.login-form h2 {
  margin: 0px;
  text-align: center;
}

.login-form h5 {
  margin: 5px;
  text-align: center;
}

.login-logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-logo {
  width: 100px;
  height: auto;
}


.login-button {
  width: 100%;
  padding: 10px;
  background-color: #374151;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.login-button:hover {
  background-color: #97afd1;
}

.login-header {
  position: relative;
  background-color: rgba(56, 65, 81, 0.9) !important;
  padding: 10px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  border-bottom: 2px solid #1c3e1d;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  z-index: 2;
}

.header-logo {
  width: auto;
  height: 100px;
}

.login-header h1 {
  color: #fff;
  margin: 0px;
  text-align: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.login-footer {
  background-color: rgba(56, 65, 81, 0.9) !important;
  color: #fff;
  padding: 10px 20px;
  border-top: 1px solid #1c3e1d;
  position: fixed;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.footer-logo {
  width: auto;
  height: 28px;
  margin-right: 10px;
}

.form {
  border-radius: 8px !important;
  background-color: rgba(56, 65, 81, 0.9) !important;
  color: white !important;
  font-family: Arial, sans-serif !important;
  position: absolute !important;
  z-index: 1000 !important;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25) !important;
  max-width: 60% !important;
  width: 40% !important;
  height: auto !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  padding: 10px !important;
  font-size: 14px !important;
  overflow: auto !important;
}

/* Close button for forms */
.form .ol-closebox {
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
  cursor: pointer !important;
  color: white !important;
  font-size: 20px !important;
}

/* Buttons within forms */
.form .dialog-buttons {
  display: flex !important;
  justify-content: flex-end !important;
}

.form .dialog-buttons button {
  padding: 10px 15px !important;
  border: none !important;
  border-radius: 5px !important;
  cursor: pointer !important;
  margin-left: 10px !important;
  background-color: #374151 !important;
  color: white !important;
}

.form .dialog-buttons button:hover {
  background-color: #008854 !important;
}

/* Input fields inside forms */
.form input[type="text"],
.form select,
.form textarea {
  width: 100% !important;
  padding: 5px !important;
  border: 1px solid #ccc !important;
  border-radius: 4px !important;
  resize: vertical !important;
  background-color: #1c3e1d !important;
  color: white !important;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.login-error {
  color: red;
  margin-bottom: 18px;
  text-align: center;
}

.error {
  color: red;
  margin-bottom: 15px;
  text-align: center;
}

.ol-layerswitcher .ol-unselectable .ol-control .ol-collapsed {
  background-color: #ffffff !important;
}

.ol-control.ol-layerswitcher {
  position: absolute;
  right: 10px !important;
  top: 3em;
  width: 300px;
  height: 400px;
  max-height: calc(80% - 6em) !important;
  box-sizing: border-box;
  overflow: auto;
  background-color: transparent;
}

.ol-switchertopdiv,
.ol-switcherbottomdiv {
  display: none !important;
}

.ol-overlaycontainer-stopevent .panel-container ul li {
  opacity: 1;
}

.ol-control.ol-layerswitcher .panel-container {
  overflow: auto !important;
  height: calc(100% - 45px);
  padding: 0.5em;
  border-radius: 4px !important;
}

.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label,
.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label span,
.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label span div {
  width: auto !important;
}
/* 
.panel-container ul .ol-layer-vector .li-content .layerswitcher-opacity {
  overflow: scroll;
} */

.ol-control.ol-layerswitcher::-webkit-scrollbar {
  width: 8px;
}

.ol-control.ol-layerswitcher::-webkit-scrollbar-thumb {
  background: #369;
  border-radius: 4px;
}

.ol-control.ol-layerswitcher::-webkit-scrollbar-track {
  background: #f0f0f0;
}

/* Ensure hovering on other layers maintains behavior */
.ol-layerswitcher-image li:hover {
  opacity: 1 !important;
}

/* Remove the selected layer from the list */
/* .ol-layerswitcher-image li.selected-layer {
  display: none !important;
} */

.ol-control.ol-layerswitcher-image.ol-collapsed {
  right: 10px !important; 
  top: 90% !important;
  position: absolute;  
  transition: all 0.2s ease 0s;
  -webkit-transition: all 0.2s ease 0s;
}

.ol-control.ol-bar .ol-bar {
  position:  absolute !important;
}

/* Ensure the LayerSwitcher button is always visible */
.ol-layerswitcher-image>button {
  
  display: block !important;
  background-color: white !important;
  width: 64px;
  height: 64px;
  outline: 2px solid rgba(28, 52, 29);
  
}

.ol-layerswitcher-image>button:hover {
  
  display: block !important;
  background-color: white !important;
  width: 64px;
  height: 64px;
  outline: 2px solid rgba(28, 52, 29);  
}

/* Ensure hovering on list items inside the panel */
.ol-layerswitcher-image .panel li:hover {
  content: attr(title);
  background-color: rgba(28, 52, 29, 0.5);
}

.ol-imgcontainer {
  width: 64px;
  height: 64px;
}

/* .ol-imgcontainer:hover {
  width: auto;
  height: auto;
  content: attr(title);
} */

.mouse-position {
  background-color: rgba(255, 255, 255, 0.75);
  font-size: 12px;
  padding: 5px;
  border-radius: 4px;
  position: absolute;
  bottom: 55px;
  left: 140px !important;
  z-index: 5;
  box-shadow: 0 1px 3px rgba(128, 128, 128, 0.25);
  transform: translateX(-50%) !important;
  align-items: center !important;
  justify-content: center !important;
}

.ol-scale-bar {
  position: absolute;
  bottom: 10px;
  left: 140px !important;
  padding: 3px;
  border-radius: 4px;
  font-size: 11px;
  z-index: 5;
  min-width: 80px;
  height: 30px;
  transform: translateX(-50%) !important;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.ol-scale-text {
  text-align: center;
  font-size: 9px !important;
  margin-bottom: 5px !important;
  color: #333;
  white-space: nowrap;
}

.ol-popup {
  position: absolute;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #cccccc;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  max-width: 300px;
  white-space: nowrap;
  cursor: default;
}

.popup-content {
  font-size: 14px;
}

.ol-layerswitcher-image > button:before, .ol-layerswitcher-image > button:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-radius: 0.15em;  
}

#map > div > div.ol-overlaycontainer-stopevent > div.ol-layerswitcher-image.ol-unselectable.ol-control.ol-collapsed.custom-layer-switcher-image.ol-forceopen {
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  align-items: center;
}

.ol-layerswitcher-image li.ol-layer-hidden {
  opacity: 0.5;
  border-color: #1c3e1d;
}

.ol-layerswitcher-image li.select, .ol-layerswitcher-image li.ol-visible {
  border: 2px solid red;
}

.ol-layerswitcher-image li {
  border-radius: 4px;
  border: 2px solid transparent;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
  width: 64px;
  height: 64px;
  margin: 1px;
  position: relative;
  background-color: #fff;
  overflow: hidden;
  vertical-align: middle;
  cursor: pointer;
}


/* #map > div > div.ol-overlaycontainer-stopevent > div.date-dialog.ol-ext-dialog.ol-visible {    
  position: absolute;
  top: -200px;
  left: 30%;
} */

/* #map > div > div.ol-overlaycontainer-stopevent > div.feature-dialog.ol-ext-dialog.ol-visible{

} */

#map > div > div.ol-overlaycontainer-stopevent > div.ol-layerswitcher-image.ol-unselectable.ol-control.ol-collapsed.ol-forceopen > div.panel-container {
  display: flex;
}

/* Hide LayerSwitcherImage when a layer is selected */
.ol-layerswitcher-image li.select,
.ol-layerswitcher-image li.ol-visible {
  background-color: #008854; /* Example highlight for selected layer */
}

.ol-layerswitcher-image.ol-forceopen li.select,
.ol-layerswitcher-image.ol-forceopen li.ol-visible {
  display: none; /* Hide the control after selection */
}

/* Ensure the main switcher button remains accessible */
.ol-layerswitcher-image > button {
  display: block !important;
}

.ol-layerswitcher-image.ol-collapsed > button {
  display: block !important;
  background-color: #fff !important;
}
/* 
#map > div > div.ol-overlaycontainer-stopevent > div:nth-child(8) > form {
  
} */

/* Dialog Container */
.dialog-mobile {
  display: flex !important; /* Force flex display */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

/* Mobile Form Styling */
#coordinates-mobile {
  display: flex;
  flex-direction: column;  
  border-radius: 8px;  
}

/* Input Fields */
#coordinates-mobile label {
  font-weight: bold;
  margin-bottom: 5px;
}

#coordinates-mobile input[type="text"] {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
}

/* Button Styling */
#coordinates-mobile button {
  padding: 8px 12px;
  margin-top: 6px;
  background-color: #008854;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#coordinates-mobile button:hover {
  background-color: #0ddf8e;
}

#map > div > div.ol-overlaycontainer-stopevent > div.feature-dialog.ol-ext-dialog.ol-visible>form {
  cursor: default;
  position: absolute;
  left: 35% !important;
  width: 35% !important; 
}

.dialog-desktop.ol-ext-dialog.ol-visible>form {
  width: 15% !important;
}

form.date-form {
  position: fixed;
  left: 50% !important;  
}

/* Custom Dialog Container */
.custom-dialog {
  position: fixed;
  border-radius: 8px;
  background-color: rgba(56, 65, 81, 0.9);
  color: white;
  font-family: Arial, sans-serif;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  max-width: 40%;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  overflow: auto;
  font-size: 14px;
}

/* Close Button */
.custom-dialog .closebox {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 20px;
  color: white;
  background: none;
  border: none;
}

/* Dialog Buttons */
.custom-dialog .dialog-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.custom-dialog .dialog-buttons button {
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
  background-color: #374151;
  color: white;
}

.custom-dialog .dialog-buttons button:hover {
  background-color: #008854;
}

/* Input Fields */
.custom-dialog input[type="text"],
.custom-dialog select,
.custom-dialog textarea,
.custom-dialog input[type="date"] {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 10px;
  background-color: #1c3e1d;
  color: white;
}

/* Labels */
.custom-dialog label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
  color: #d1d5db;
}

/* Form Group Styling */
.custom-dialog .form-group {
  margin-bottom: 15px;
}

/* Dual Listbox Styling */
.custom-dialog .dual-listbox {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.custom-dialog .dual-listbox .listbox {
  width: 45%;
}

.custom-dialog .dual-listbox ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 150px;
  overflow-y: auto;
  background-color: #eae4e3;
  color: #1c3e1d;
}

.custom-dialog .dual-listbox ul li {
  padding: 5px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}

.custom-dialog .dual-listbox ul li:hover,
.custom-dialog .dual-listbox ul li:focus {
  background-color: #4b5563;
  color: white;
}

.custom-dialog .dual-listbox ul li.selected {
  background-color: #4b5563;
  color: white;
}

/* Dual Listbox Buttons */
.custom-dialog .dual-listbox .listbox-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}

.custom-dialog .dual-listbox .listbox-buttons button {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background-color: #aecdb1;
  color: #1c3e1d;
  cursor: pointer;
}

.custom-dialog .dual-listbox .listbox-buttons button:hover {
  background-color: #4b5563;
  color: white;
}

/* Media Query for Responsive Design */
@media screen and (max-width: 600px) {
  .custom-dialog {
    width: 90%;
    max-width: 90%;
    top: 20%;
    left: 50%;
    transform: translate(-50%, 0);
    padding: 15px;
  }

  .custom-dialog .dialog-buttons {
    flex-direction: column;
    gap: 10px;
    justify-content: center;
  }
}

#map > div > div.ol-overlaycontainer-stopevent > div.upload-dialog.ol-ext-dialog.ol-visible > form {
  width: 35%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kCAA6B;EAA7B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,qBAAqB;;AAEvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,kEAAkE;AAClE;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,sCAAsC;AACxC;;;AAGA;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE;;;IAGE,WAAW;IACX,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;AAEF;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;IAII;;AAEJ;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA,wCAAwC;AACxC;;EAEE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,YAAY;AACd;;AAEA,iEAAiE;AACjE;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,SAAS;EACT,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,wBAAwB;EACxB,4BAA4B;EAC5B,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,uCAAuC;EACvC,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,+CAA+C;EAC/C,UAAU;EACV,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gCAAgC;EAChC,uCAAuC;EACvC,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;;;AAIA;EACE,cAAc;EACd,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,qDAAqD;EACrD;IACE,aAAa;EACf;;AAEF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,2CAA2C;EAC3C,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;EAClD,uBAAuB;EACvB,yCAAyC;EACzC,6BAA6B;EAC7B,wBAAwB;EACxB,sDAAsD;EACtD,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,yBAAyB;AACzB;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,4BAA4B;EAC5B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,8BAA8B;AAC9B;;;EAGE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;;EAGE,sBAAsB;AACxB;AACA;;;GAGG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;;GAEG;;AAEH;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,mCAAmC;;AAErC;;AAEA;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA,mDAAmD;AACnD;EACE,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;;GAIG;;AAEH;EACE,2CAA2C;EAC3C,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,UAAU;EACV,+CAA+C;EAC/C,sCAAsC;EACtC,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0CAA0C;EAC1C,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;;AAGA;;;;GAIG;;AAEH;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA,qDAAqD;AACrD;;EAEE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;;EAEE,aAAa,EAAE,qCAAqC;AACtD;;AAEA,uDAAuD;AACvD;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;AACA;;;GAGG;;AAEH,qBAAqB;AACrB;EACE,wBAAwB,EAAE,uBAAuB;EACjD,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,8BAA8B;EAC9B,2CAA2C;EAC3C,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;;;;EAIE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;AAEA,WAAW;AACX;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE;IACE,UAAU;IACV,cAAc;IACd,QAAQ;IACR,SAAS;IACT,6BAA6B;IAC7B,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;AACF;;AAEA;EACE,UAAU;AACZ","sourcesContent":["* {\n  box-sizing: border-box;\n}\n\n.ol-control.ol-bar .ol-toggle.ol-active > button, .ol-control.ol-bar .ol-toggle.ol-active button:hover {\n  background-color: #008854 !important;\n}\n\nbody,\nhtml {\n  height: 100% !important;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: #d9e6de;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n#map {  \n  width: 100%;\n  height: 100vh;\n  flex: 1;\n  z-index: 0;\n  position: absolute;\n}\n\n#user-marker {\n  width: 16px;\n  height: 16px;\n  background-color: transparent;\n  border: none;\n  display: block;\n  position: relative;\n}\n\ninput[type=text],\nselect,\ntextarea {\n  width: 100%;\n  padding: 6px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  resize: vertical;\n}\n\nlabel {\n  padding: 6px 6px 6px 0;\n  display: inline-block;\n}\n\n.ol-ext-dialog {  \n  border-radius: 5px;\n  padding: 20px;\n  color: white; \n  position: fixed;\n}\n\n.ol-closebox {\n  width: fit-content !important;\n  padding: 15px;  \n}\n\n.ol-content {\n  padding: 10px;\n}\n\n.ol-ext-dialog.ol-visible {\n  background-color: transparent;\n}\n\n.ol-ext-dialog form {\n  border-radius: 5px;\n  background-color: rgba(28, 62, 29, 0.9) !important;\n  /* width: 30% !important; */\n  height: auto;\n  color: white;\n  font-family: Arial, sans-serif;   \n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  font-size: 14px;  \n}\n\n/* Close Button  */\n.ol-ext-dialog form .ol-closebox {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  cursor: pointer;\n  color: white;\n  font-size: 15px;\n}\n\n/* Form Buttons */\n.ol-ext-dialog form .dialog-buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.ol-ext-dialog form .dialog-buttons button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n  background-color: #374151;\n  color: white;\n}\n\n.ol-ext-dialog form .dialog-buttons button:hover {\n  background-color: #4b5563;\n}\n\n.date-dialog {\n  width: 35%;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.col-25 {\n  flex: 0 0 25%;\n  max-width: 25%;\n  padding-right: 15px;\n  text-align: left;\n  float: left;\n  width: 25%;\n  font-size: 14px;\n  font-weight: 600;\n  /* margin-top: 6px; */\n\n}\n\n.col-75 {\n  flex: 1 1 75% ;\n  max-width: 75%;\n}\n\n.col-75 input,\n.col-75 textarea,\n.col-75 select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.error-message {\n  color: red;\n  font-size: 0.8em;\n  margin-top: 5px;\n}\n\n.div.ol-ext-dialog.ol-visible > .form > .div.ol-content > .div:nth-child(4) > .div.col-75.dual-listbox > .div:nth-child(3) > .h4 {\n  margin: 0%;\n}\n\n/* Style for the color, background, and opacity input containers */\ninput[type=\"color\"],\ninput[name=\"background\"],\ninput[name=\"opacity\"] {\n  width: 50px !important;\n  height: 30px !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 4px !important;\n  cursor: pointer;\n  display: inline-block;\n  margin: 5px;\n  box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);\n}\n\n\ninput[name=\"opacity\"] {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #f0f0f0;\n  text-align: center;\n}\n\n.col-75.iconpicker-container {\n  display: flex;\n  align-items: center;\n}\n\n.col-75.iconpicker-container i {\n  margin-right: 10px;\n  font-size: 1em;\n  text-align: left;\n  flex-shrink: 0;\n}\n\n.iconpicker .iconpicker-item {\n  float: left;\n  width: 20px;\n  padding: 6px;\n  margin: 0 6px 6px 0;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 3px;\n  font-size: 14px;\n  box-shadow: 0 0 0 1px #ddd;\n  color: inherit;\n}\n\n.row::after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.dual-listbox {\n  display: flex;\n  justify-content: space-around;\n}\n\n.listbox {\n  white-space: nowrap;  \n}\n\n.listbox ul {\n  list-style-type: none;\n  padding: 0;\n  border: 1px solid #ccc;\n  height: 100px;\n  overflow-y: auto;\n  border-radius: 4px;\n  background-color: #eae4e3;\n  color: #1c3e1d;\n}\n\n.listbox ul li {\n  padding: 5px;\n  cursor: pointer;\n  border-bottom: 1px solid #ccc;\n}\n\n.listbox ul li:hover,\n.listbox ul li:active,\n.listbox ul li:focus {\n  background-color: #4b5563;\n  border-color: #4b5563;\n}\n\n.listbox ul li.selected {\n  background-color: #4b5563;\n  border-color: #4b5563;\n}\n\n.listbox-buttons {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.listbox-buttons button {\n  margin: 5px 0;\n  padding: 8px;  \n  background-color: #aecdb1;\n  color: #1c3e1d;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn {\n  color: white;\n  font-size: 20px;\n  margin: 26px 24px 0 0;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  float: right;\n  background-color: #374151;\n  padding: 10px 15px;\n}\n\n@media screen and (max-width: 600px) {\n\n  .col-25,\n  .col-75,\n  input[type=submit] {\n    width: 100%;\n    margin-top: 0;\n    font-size: 12px;\n  }\n\n  .ol-ext-dialog form {    \n    top: 15% !important;\n    left: 40% !important;\n  }\n\n}\n\n.control-bar {\n  border-radius: 0px !important;  \n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 64px;\n  height: 100vh;\n  background-color: #1f2937 !important;\n  padding: 2px;\n  position: relative !important;\n  top: 0 !important;\n  left: 0 !important;\n  overflow: hidden;\n}\n\n.control-bar .ol-button button {\n  background-color: #1f2937;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  margin-top: 6px;\n  border-radius: 8px;\n  color: #fff !important;\n  text-decoration: none;\n  border: none;  \n}\n\n.control-bar .ol-button button:hover {\n  background-color: #374151;\n  color: #fff;\n}\n\n/* .dialog-mobile {\n  position: absolute;\n  top: -35% !important;\n  left: 50% !important;\n}  */\n\n.dialog-desktop {\n  position: absolute;\n  top: 50px;\n  left: 50px;\n}\n\n/* Horizontal top-centered control bar */\n.ol-button .ol-unselectable .ol-control,\n.base-control-bar {\n  border-radius: 0px;\n  margin: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  height: 64px;\n  padding: 2px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  overflow: hidden;\n}\n\n.base-control-bar {\n  background: transparent !important;\n  padding: 0px !important;\n}\n\n/* Button styling for the horizontal control bar */\n.base-control-bar .ol-button button {\n  background-color: #1f2937;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin: 0 8px;\n  border-radius: 4px;\n  color: #fff;\n  text-decoration: none;\n  border: none;\n}\n\n/* Hover, focus, and active states (but exclude active buttons) */\n.base-control-bar .ol-button button:hover {\n  background-color: #374151;\n  color: #fff;\n}\n\n.base-control-bar .ol-button button:active,\n.base-control-bar .ol-button button:focus {\n  color: #fff !important;\n}\n\n.non-fuel {\n  margin-top: auto !important;\n  margin-bottom: 16px !important;\n}\n\n.section {\n  padding-right: 6px !important;\n  margin-right: 6px !important;\n}\n\n.draw-polygon {\n  padding-right: 6px !important;\n  margin-right: 6px !important;\n}\n\n.sidebar-section {\n  border-bottom: 1px solid #4b5563;\n  padding-bottom: 6px !important;\n  margin-bottom: 3px !important;\n}\n\n.account {\n  margin-top: auto !important;\n  margin-bottom: 16px !important;\n  background-color: #374151 !important;\n}\n\n.account button {\n  background-color: transparent !important;\n  margin: 0 0 6px 0 !important;\n  padding: 0px !important;\n}\n\n.account:hover,\n.account button:hover {\n  background-color: #4b5563 !important;\n  color: #d1d5db !important;\n}\n\n.ol-notification .ol-close {\n  background-color: rgba(63, 99, 71, 0.95);\n  color: #ffffff;\n  padding: 10px;\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  margin: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.ol-notification .ol-close:hover {\n  background-color: rgba(63, 99, 71, 0.95);\n  color: #ffffff;\n  padding: 10px;\n  border: 1px solid #ffffff;\n  border-radius: 4px;\n  margin: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 18px;\n}\n\n.uploader {\n  width: 24px;\n  height: 6px;\n  margin-top: 10px;\n  background: #FFF;\n  display: inline-block;\n  position: relative;\n}\n\n.uploader::after {\n  content: '';  \n  left: 50%;\n  top: -24px;\n  transform: translate(-50%, 0);\n  position: absolute;\n  border: 8px solid transparent;\n  border-bottom-color: #FFF;\n  box-sizing: border-box;\n  animation: bump 0.4s ease-in-out infinite alternate;\n}\n\n.uploader::before {\n  content: '';  \n  left: 50%;\n  bottom: 7px;\n  transform: translate(-50%, 0);\n  position: absolute;\n  width: 8px;\n  height: 10px;\n  background: #FFF;\n  box-sizing: border-box;\n  animation: bump 0.4s ease-in-out infinite alternate;\n}\n\n@keyframes bump {\n  0% {\n    transform: translate(-50%, 5px);\n  }\n  100% {\n    transform: translate(-50%, -5px);\n  }\n}\n\n.loading {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f0f0;\n}\n\n.loader {\n  border: 6px solid #f3f3f3;\n  border-top: 6px solid #1c3e1d;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin: auto;\n  display: block;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.sec-loading {\n  height: 80px;\n  width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.sec-loading .one {\n  height: 80px;\n  width: 80px;\n  border: 4px solid rgb(104, 133, 146);\n  transform: rotate(45deg);\n  border-radius: 0 50% 50% 50%;\n  position: relative;\n  animation: move 0.5s linear infinite alternate-reverse;\n}\n\n.sec-loading .one::before {\n  content: \"\";\n  position: absolute;\n  height: 55%;\n  width: 55%;\n  border-radius: 50%;\n  border: 4px solid transparent;\n  border-top-color: rgb(104, 133, 146);\n  border-bottom-color: rgb(104, 133, 146);\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: rotate 1s linear infinite;\n}\n\n@keyframes rotate {\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n@keyframes move {\n  to {\n    transform: translateY(15px) rotate(45deg);\n  }\n}\n\n.loading h2 {\n  color: #33406F;\n  font-size: 1.5em;\n}\n\n.iconpicker-popover .popover-content .iconpicker {\n  height: 150px !important;\n}\n\n.iconpicker .iconpicker-item {\n  background-color: #374151 !important;\n  color: #e6e6e6 !important;\n}\n\n.iconpicker .iconpicker-item:hover {\n  background-color: #4b5361 !important;\n}\n\n#pselect {\n  padding: 6px;  \n  align-content: center;  \n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-label {\n  background-color: #f1f1f1;\n  padding: 10px;\n  cursor: pointer;\n  border: 1px solid #ccc;\n}\n\n.dropdown-list {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 200px;\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n  padding: 10px;\n}\n\n.dropdown.on .dropdown-list {\n  display: block;\n}\n\n.feature-popup {\n  background-color: rgba(28, 62, 29, 0.9);\n  color: white;\n  padding: 10px;\n  width: 250px;\n  border-radius: 8px;\n  z-index: 1000;\n  font-size: 14px;\n  cursor: default;\n}\n\n.feature-popup h2 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.non-fuel-dialog {\n  position: absolute;\n  top: 60%;\n  right: 10%;\n  transform: translate(-50%, -50%);\n  background-color: rgba(28, 62, 29, 0.9);\n  color: white;\n  padding: 10px;\n  width: 250px;\n  border-radius: 8px;\n  z-index: 1000;\n  font-size: 14px;\n  cursor: move;\n  overflow: auto;\n}\n\n.non-fuel-dialog h2 {\n  font-size: 16px;\n  margin-bottom: 5px;\n}\n\n.non-fuel-dialog input {\n  width: 100%;\n  padding: 6px;\n  margin-bottom: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.non-fuel-dialog p {\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n\n.non-fuel-dialog .dialog-buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.non-fuel-dialog .dialog-buttons button {\n  padding: 6px 10px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  margin-left: 10px;\n}\n\n.non-fuel-dialog #cancel-btn {\n  background-color: #bbb;\n  color: #333;\n}\n\n.non-fuel-dialog #confirm-btn {\n  background-color: #008854;\n  color: #fff;\n}\n\n.non-fuel-dialog #cancel-btn:hover {\n  background-color: #ddd;\n}\n\n.non-fuel-dialog #confirm-btn:hover {\n  background-color: #4b5563;\n}\n\n.non-fuel-dialog .fa-spinner {\n  margin-right: 5px;\n}\n\n.error {\n  color: red !important;\n  font-size: 12px !important;\n  margin-top: 5px !important;\n}\n\n.login-error {\n  color: red !important;\n  font-size: 16px !important;\n}\n\n\n\n.coordinates-container {\n  margin: 10px 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 5px;\n  position: absolute;\n  top: 60px;\n  right: 20px;\n  font-size: 14px;\n  z-index: 1000;\n  display: block;\n}\n\n.title {\n  margin-bottom: 10px;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.coordinates h3 {\n  margin: 5px 0;\n  font-size: 14px;\n}\n\n.coordinates p {\n  margin: 0;\n  padding: 2px 0;\n}\n\n.coordinates p:last-child {\n  margin-bottom: 0;\n}\n\n.information-container {\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #ffffff;\n  padding: 10px;\n  border-radius: 5px 5px 5px 5px;\n  top: 60px;\n  left: -300px;\n  width: 250px;\n  font-size: 14px;\n  z-index: 2;\n  transition: left 0.3s ease-in-out;\n  display: block;\n}\n\n.information-container.open {\n  left: 100px;\n}\n\n@media only screen and (max-width: 767px) {\n\n  /* Hide the information container on mobile devices */\n  .information-container {\n    display: none;\n  }\n  \n}\n\n.drawer-toggle-button {\n  position: relative;\n  top: 20px;\n  right: 20px;\n  background-color: #333;\n  color: #fff;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  z-index: 1001;\n  border-radius: 5px;\n}\n\n.login-form {\n  display: block;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: 400px;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: rgba(56, 65, 81, 0.9);\n  color: white;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  cursor: default;\n  z-index: 1000;\n}\n\n.login-form h2 {\n  margin: 0px;\n  text-align: center;\n}\n\n.login-form h5 {\n  margin: 5px;\n  text-align: center;\n}\n\n.login-logo-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-logo {\n  width: 100px;\n  height: auto;\n}\n\n\n.login-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #374151;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.login-button:hover {\n  background-color: #97afd1;\n}\n\n.login-header {\n  position: relative;\n  background-color: rgba(56, 65, 81, 0.9) !important;\n  padding: 10px;\n  text-align: center;\n  font-size: 24px;\n  font-weight: bold;\n  color: #fff;\n  border-bottom: 2px solid #1c3e1d;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  z-index: 2;\n}\n\n.header-logo {\n  width: auto;\n  height: 100px;\n}\n\n.login-header h1 {\n  color: #fff;\n  margin: 0px;\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.login-footer {\n  background-color: rgba(56, 65, 81, 0.9) !important;\n  color: #fff;\n  padding: 10px 20px;\n  border-top: 1px solid #1c3e1d;\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\n.footer-logo {\n  width: auto;\n  height: 28px;\n  margin-right: 10px;\n}\n\n.form {\n  border-radius: 8px !important;\n  background-color: rgba(56, 65, 81, 0.9) !important;\n  color: white !important;\n  font-family: Arial, sans-serif !important;\n  position: absolute !important;\n  z-index: 1000 !important;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25) !important;\n  max-width: 60% !important;\n  width: 40% !important;\n  height: auto !important;\n  top: 50% !important;\n  left: 50% !important;\n  transform: translate(-50%, -50%) !important;\n  padding: 10px !important;\n  font-size: 14px !important;\n  overflow: auto !important;\n}\n\n/* Close button for forms */\n.form .ol-closebox {\n  position: absolute !important;\n  top: 10px !important;\n  right: 10px !important;\n  cursor: pointer !important;\n  color: white !important;\n  font-size: 20px !important;\n}\n\n/* Buttons within forms */\n.form .dialog-buttons {\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n\n.form .dialog-buttons button {\n  padding: 10px 15px !important;\n  border: none !important;\n  border-radius: 5px !important;\n  cursor: pointer !important;\n  margin-left: 10px !important;\n  background-color: #374151 !important;\n  color: white !important;\n}\n\n.form .dialog-buttons button:hover {\n  background-color: #008854 !important;\n}\n\n/* Input fields inside forms */\n.form input[type=\"text\"],\n.form select,\n.form textarea {\n  width: 100% !important;\n  padding: 5px !important;\n  border: 1px solid #ccc !important;\n  border-radius: 4px !important;\n  resize: vertical !important;\n  background-color: #1c3e1d !important;\n  color: white !important;\n}\n\n.form-group {\n  margin-bottom: 10px;\n}\n\n.form-group label {\n  display: block;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.login-error {\n  color: red;\n  margin-bottom: 18px;\n  text-align: center;\n}\n\n.error {\n  color: red;\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.ol-layerswitcher .ol-unselectable .ol-control .ol-collapsed {\n  background-color: #ffffff !important;\n}\n\n.ol-control.ol-layerswitcher {\n  position: absolute;\n  right: 10px !important;\n  top: 3em;\n  width: 300px;\n  height: 400px;\n  max-height: calc(80% - 6em) !important;\n  box-sizing: border-box;\n  overflow: auto;\n  background-color: transparent;\n}\n\n.ol-switchertopdiv,\n.ol-switcherbottomdiv {\n  display: none !important;\n}\n\n.ol-overlaycontainer-stopevent .panel-container ul li {\n  opacity: 1;\n}\n\n.ol-control.ol-layerswitcher .panel-container {\n  overflow: auto !important;\n  height: calc(100% - 45px);\n  padding: 0.5em;\n  border-radius: 4px !important;\n}\n\n.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label,\n.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label span,\n.ol-control.ol-layerswitcher .panel-container ul .ol-layer-vector .li-content label span div {\n  width: auto !important;\n}\n/* \n.panel-container ul .ol-layer-vector .li-content .layerswitcher-opacity {\n  overflow: scroll;\n} */\n\n.ol-control.ol-layerswitcher::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ol-control.ol-layerswitcher::-webkit-scrollbar-thumb {\n  background: #369;\n  border-radius: 4px;\n}\n\n.ol-control.ol-layerswitcher::-webkit-scrollbar-track {\n  background: #f0f0f0;\n}\n\n/* Ensure hovering on other layers maintains behavior */\n.ol-layerswitcher-image li:hover {\n  opacity: 1 !important;\n}\n\n/* Remove the selected layer from the list */\n/* .ol-layerswitcher-image li.selected-layer {\n  display: none !important;\n} */\n\n.ol-control.ol-layerswitcher-image.ol-collapsed {\n  right: 10px !important; \n  top: 90% !important;\n  position: absolute;  \n  transition: all 0.2s ease 0s;\n  -webkit-transition: all 0.2s ease 0s;\n}\n\n.ol-control.ol-bar .ol-bar {\n  position:  absolute !important;\n}\n\n/* Ensure the LayerSwitcher button is always visible */\n.ol-layerswitcher-image>button {\n  \n  display: block !important;\n  background-color: white !important;\n  width: 64px;\n  height: 64px;\n  outline: 2px solid rgba(28, 52, 29);\n  \n}\n\n.ol-layerswitcher-image>button:hover {\n  \n  display: block !important;\n  background-color: white !important;\n  width: 64px;\n  height: 64px;\n  outline: 2px solid rgba(28, 52, 29);  \n}\n\n/* Ensure hovering on list items inside the panel */\n.ol-layerswitcher-image .panel li:hover {\n  content: attr(title);\n  background-color: rgba(28, 52, 29, 0.5);\n}\n\n.ol-imgcontainer {\n  width: 64px;\n  height: 64px;\n}\n\n/* .ol-imgcontainer:hover {\n  width: auto;\n  height: auto;\n  content: attr(title);\n} */\n\n.mouse-position {\n  background-color: rgba(255, 255, 255, 0.75);\n  font-size: 12px;\n  padding: 5px;\n  border-radius: 4px;\n  position: absolute;\n  bottom: 55px;\n  left: 140px !important;\n  z-index: 5;\n  box-shadow: 0 1px 3px rgba(128, 128, 128, 0.25);\n  transform: translateX(-50%) !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.ol-scale-bar {\n  position: absolute;\n  bottom: 10px;\n  left: 140px !important;\n  padding: 3px;\n  border-radius: 4px;\n  font-size: 11px;\n  z-index: 5;\n  min-width: 80px;\n  height: 30px;\n  transform: translateX(-50%) !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.ol-scale-text {\n  text-align: center;\n  font-size: 9px !important;\n  margin-bottom: 5px !important;\n  color: #333;\n  white-space: nowrap;\n}\n\n.ol-popup {\n  position: absolute;\n  background-color: white;\n  padding: 10px;\n  border-radius: 4px;\n  border: 1px solid #cccccc;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n  max-width: 300px;\n  white-space: nowrap;\n  cursor: default;\n}\n\n.popup-content {\n  font-size: 14px;\n}\n\n.ol-layerswitcher-image > button:before, .ol-layerswitcher-image > button:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-radius: 0.15em;  \n}\n\n#map > div > div.ol-overlaycontainer-stopevent > div.ol-layerswitcher-image.ol-unselectable.ol-control.ol-collapsed.custom-layer-switcher-image.ol-forceopen {\n  display: flex;\n  flex-direction: row-reverse;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.ol-layerswitcher-image li.ol-layer-hidden {\n  opacity: 0.5;\n  border-color: #1c3e1d;\n}\n\n.ol-layerswitcher-image li.select, .ol-layerswitcher-image li.ol-visible {\n  border: 2px solid red;\n}\n\n.ol-layerswitcher-image li {\n  border-radius: 4px;\n  border: 2px solid transparent;\n  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);\n  display: inline-block;\n  width: 64px;\n  height: 64px;\n  margin: 1px;\n  position: relative;\n  background-color: #fff;\n  overflow: hidden;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n\n/* #map > div > div.ol-overlaycontainer-stopevent > div.date-dialog.ol-ext-dialog.ol-visible {    \n  position: absolute;\n  top: -200px;\n  left: 30%;\n} */\n\n/* #map > div > div.ol-overlaycontainer-stopevent > div.feature-dialog.ol-ext-dialog.ol-visible{\n\n} */\n\n#map > div > div.ol-overlaycontainer-stopevent > div.ol-layerswitcher-image.ol-unselectable.ol-control.ol-collapsed.ol-forceopen > div.panel-container {\n  display: flex;\n}\n\n/* Hide LayerSwitcherImage when a layer is selected */\n.ol-layerswitcher-image li.select,\n.ol-layerswitcher-image li.ol-visible {\n  background-color: #008854; /* Example highlight for selected layer */\n}\n\n.ol-layerswitcher-image.ol-forceopen li.select,\n.ol-layerswitcher-image.ol-forceopen li.ol-visible {\n  display: none; /* Hide the control after selection */\n}\n\n/* Ensure the main switcher button remains accessible */\n.ol-layerswitcher-image > button {\n  display: block !important;\n}\n\n.ol-layerswitcher-image.ol-collapsed > button {\n  display: block !important;\n  background-color: #fff !important;\n}\n/* \n#map > div > div.ol-overlaycontainer-stopevent > div:nth-child(8) > form {\n  \n} */\n\n/* Dialog Container */\n.dialog-mobile {\n  display: flex !important; /* Force flex display */\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n/* Mobile Form Styling */\n#coordinates-mobile {\n  display: flex;\n  flex-direction: column;  \n  border-radius: 8px;  \n}\n\n/* Input Fields */\n#coordinates-mobile label {\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n#coordinates-mobile input[type=\"text\"] {\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Button Styling */\n#coordinates-mobile button {\n  padding: 8px 12px;\n  margin-top: 6px;\n  background-color: #008854;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n#coordinates-mobile button:hover {\n  background-color: #0ddf8e;\n}\n\n#map > div > div.ol-overlaycontainer-stopevent > div.feature-dialog.ol-ext-dialog.ol-visible>form {\n  cursor: default;\n  position: absolute;\n  left: 35% !important;\n  width: 35% !important; \n}\n\n.dialog-desktop.ol-ext-dialog.ol-visible>form {\n  width: 15% !important;\n}\n\nform.date-form {\n  position: fixed;\n  left: 50% !important;  \n}\n\n/* Custom Dialog Container */\n.custom-dialog {\n  position: fixed;\n  border-radius: 8px;\n  background-color: rgba(56, 65, 81, 0.9);\n  color: white;\n  font-family: Arial, sans-serif;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n  max-width: 40%;\n  width: auto;\n  height: auto;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 20px;\n  overflow: auto;\n  font-size: 14px;\n}\n\n/* Close Button */\n.custom-dialog .closebox {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n  font-size: 20px;\n  color: white;\n  background: none;\n  border: none;\n}\n\n/* Dialog Buttons */\n.custom-dialog .dialog-buttons {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.custom-dialog .dialog-buttons button {\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n  background-color: #374151;\n  color: white;\n}\n\n.custom-dialog .dialog-buttons button:hover {\n  background-color: #008854;\n}\n\n/* Input Fields */\n.custom-dialog input[type=\"text\"],\n.custom-dialog select,\n.custom-dialog textarea,\n.custom-dialog input[type=\"date\"] {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  background-color: #1c3e1d;\n  color: white;\n}\n\n/* Labels */\n.custom-dialog label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n  color: #d1d5db;\n}\n\n/* Form Group Styling */\n.custom-dialog .form-group {\n  margin-bottom: 15px;\n}\n\n/* Dual Listbox Styling */\n.custom-dialog .dual-listbox {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.custom-dialog .dual-listbox .listbox {\n  width: 45%;\n}\n\n.custom-dialog .dual-listbox ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  height: 150px;\n  overflow-y: auto;\n  background-color: #eae4e3;\n  color: #1c3e1d;\n}\n\n.custom-dialog .dual-listbox ul li {\n  padding: 5px;\n  cursor: pointer;\n  border-bottom: 1px solid #ccc;\n}\n\n.custom-dialog .dual-listbox ul li:hover,\n.custom-dialog .dual-listbox ul li:focus {\n  background-color: #4b5563;\n  color: white;\n}\n\n.custom-dialog .dual-listbox ul li.selected {\n  background-color: #4b5563;\n  color: white;\n}\n\n/* Dual Listbox Buttons */\n.custom-dialog .dual-listbox .listbox-buttons {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n\n.custom-dialog .dual-listbox .listbox-buttons button {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  background-color: #aecdb1;\n  color: #1c3e1d;\n  cursor: pointer;\n}\n\n.custom-dialog .dual-listbox .listbox-buttons button:hover {\n  background-color: #4b5563;\n  color: white;\n}\n\n/* Media Query for Responsive Design */\n@media screen and (max-width: 600px) {\n  .custom-dialog {\n    width: 90%;\n    max-width: 90%;\n    top: 20%;\n    left: 50%;\n    transform: translate(-50%, 0);\n    padding: 15px;\n  }\n\n  .custom-dialog .dialog-buttons {\n    flex-direction: column;\n    gap: 10px;\n    justify-content: center;\n  }\n}\n\n#map > div > div.ol-overlaycontainer-stopevent > div.upload-dialog.ol-ext-dialog.ol-visible > form {\n  width: 35%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
